import { AppointmentEvent, ScheduleEvent } from '@/app/models/ScheduleEvent'

export function isAppointment(
  scheduleEvent: ScheduleEvent | AppointmentEvent | undefined
): scheduleEvent is AppointmentEvent {
  return scheduleEvent !== undefined && (scheduleEvent as AppointmentEvent).patient !== undefined
}
